import { IReducerAction } from "../../interfaces/IRedux";
import {
  CLIENT_LOADING,
  CLIENT_END_LOADING,
  CLIENT_LOADING_OPERATION,
  CLIENT_END_LOADING_OPERATION,
  CLIENT_GET_DATA,
  CLIENT_GET_SINGLE,
  CLIENT_CLEAR,
  CLIENT_ADD_SINGLE,
  CLIENT_UPDATE_SINGLE,
  CLIENT_REMOVE_SINGLE,
  CLIENT_GET_ELEMENTS,
} from "../types";

const initialState = {
  loading: false,
  loadingOperation: false,
  elements: [],
  pagination: {},
  item: null,
};

export default function reducer(state = initialState, action: IReducerAction) {
  const payload = action.payload || {};

  switch (action.type) {
    case CLIENT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case CLIENT_END_LOADING:
      return {
        ...state,
        loading: false,
      };

    case CLIENT_LOADING_OPERATION:
      return {
        ...state,
        loadingOperation: true,
      };

    case CLIENT_END_LOADING_OPERATION:
      return {
        ...state,
        loadingOperation: false,
      };

    case CLIENT_GET_ELEMENTS:
      return {
        ...state,
        loading: false,
        elements: Array.isArray(payload) ? payload : [],
      };

    case CLIENT_GET_DATA:
      // @ts-ignore
      const rows = payload.rows || [];
      // @ts-ignore
      const pagination = payload.pagination || {};
      return {
        ...state,
        loading: false,
        elements: rows,
        pagination,
      };

    case CLIENT_ADD_SINGLE:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemIndex = state.elements.findIndex((e) => e.id === payload.id);
        if (itemIndex < 0) {
          state.elements.splice(0, 0, payload);
        }
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case CLIENT_UPDATE_SINGLE:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemIndex = state.elements.findIndex((e) => e.id === payload.id);
        state.elements[itemIndex] = payload;
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case CLIENT_REMOVE_SINGLE:
      if (payload && Object.keys(payload).length > 0) {
        // @ts-ignore
        const itemIndex = state.elements.findIndex((e) => e.id === payload.id);
        if (itemIndex >= 0) {
          state.elements.splice(itemIndex, 1);
        }
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case CLIENT_GET_SINGLE:
      return {
        ...state,
        loading: false,
        loadingOperation: false,
        item: payload,
      };

    case CLIENT_CLEAR:
      return initialState;
    default:
      return state;
  }
}
